<template>
    <div>
        <SubHeader :title="subHeaderTitle" :breads="[{ name: 'Dossiers', to: 'AdminUserProfileProfile' }]"
            :action="{}" />

        <div class="row">
            <div class="col-md-12">
                <div class="card">

                    <div class="card-header">
                        <div class="row justify-content-between align-items-center flex-grow-1">
                            <div class="col-12 col-md">
                                <div class="d-flex justify-content-between align-items-center">
                                    <form>
                                        <div class="input-group input-group-merge input-group-flush">
                                            <div class="input-group-prepend input-group-text">
                                                <i class="bi-search"></i>
                                            </div>
                                            <input id="datatableWithSearchInput" v-model="searchWord" type="search"
                                                class="form-control" placeholder="Rechercher">
                                        </div>
                                    </form>
                                </div>
                            </div>

                            <!-- Boutons d'action groupée (caché pour view_closed_only) -->
                            <div class="col-auto" v-if="selectedIds.length > 0 && !checkGuard('view_closed_only')">
                                <div class="row align-items-center gap-2">
                                    <div class="col">
                                        <button type="button" class="btn btn-primary btn-xs"
                                            data-bs-toggle="modal" data-bs-target="#bulkAffectationModal">

                                            Affecter ({{ selectedIds.length }})
                                        </button>
                                    </div>
                                    <div class="col">
                                        <button type="button" class="btn btn-outline-danger btn-xs" @click="clearSelection">

                                            Désélectionner
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <!-- Bouton Tout sélectionner (caché pour view_closed_only) -->
                            <div class="col-auto" v-if="!selectedIds.length && items.length > 0 && !checkGuard('view_closed_only')">
                                <button type="button" class="btn btn-outline-secondary btn-sm" @click="selectAllOnPage">
                                    <i class="bi bi-check-all me-1"></i>
                                    Tout sélectionner ({{ items.length }})
                                </button>
                            </div>

                            <div class="col-auto">
                                <!-- @if ($profile != 'Agent Support') -->
                                <div class="row align-items-center">
                                    <div class="col">
                                        <div class="dropdown">
                                            <button type="button" class="btn btn-white btn-sm w-100"
                                                id="usersFilterDropdown" data-bs-toggle="dropdown"
                                                data-bs-auto-close="outside" aria-expanded="false">
                                                <i class="bi-filter me-1" ref="filter"></i> Filtrer
                                                <!-- <span
                                                    class="badge bg-soft-dark text-dark rounded-circle ms-1">2</span> -->
                                            </button>

                                            <div class="dropdown-menu dropdown-menu-sm-end dropdown-card card-dropdown-filter-centered"
                                                aria-labelledby="usersFilterDropdown" style="min-width: 42rem;">
                                                <div class="card">
                                                    <div class="card-header card-header-content-between">
                                                        <h5 class="card-header-title">Filtrer Dossier</h5>

                                                        <button type="button" @click="this.$refs.filter.click()"
                                                            class="btn btn-ghost-secondary btn-icon btn-sm ms-2">
                                                            <i class="bi-x-lg"></i>
                                                        </button>

                                                    </div>

                                                    <div class="card-body">
                                                        <form>


                                                            <div class="row mb-2">
                                                                <div class="col-sm mb-1">
                                                                    <small class="mt-2 mb-1"><b>Institution</b></small>

                                                                    <m-select :options="institutionItems" label="label"
                                                                        track-by="label" :multiple="false"
                                                                        :loading="institutionIsLoading"
                                                                        v-model="filterData.institution_id">

                                                                    </m-select>
                                                                </div>
                                                            </div>
                                                            <div class="row  mb-2">
                                                                <div class="col-sm mb-1">
                                                                    <small class="mt-2 mb-1"><b>Canal</b></small>
                                                                    <m-select :options="categoryItems" label="label"
                                                                        track-by="label" :multiple="false"
                                                                        :loading="categoryIsLoading"
                                                                        v-model="filterData.canal_id">

                                                                    </m-select>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-12 mt-2 mb-1">
                                                                    <small class=""><b>Date</b></small>

                                                                </div>

                                                                <div class="col-sm mb-4">
                                                                    <i-range v-model="filterData.date"
                                                                        :max-date="new Date()" model-type="yyyy-MM-dd"
                                                                        multi-calendars range
                                                                        :enable-time-picker="false" />
                                                                </div>
                                                            </div>

                                                            <div class="row mx-1">
                                                                <a class="btn bg-soft-dark col-sm-4 "
                                                                    v-if="filterDataUrl != ''"
                                                                    @click="resetFilterDataSubmit">Annuler</a>
                                                                <a class="btn btn-primary"
                                                                    :class="filterDataUrl == '' ? 'col-sm-12' : 'col-sm-7 offset-lg-1'"
                                                                    @click="() => { filterDataSubmit() }">Filtrer</a>

                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-auto" v-if="!checkGuard('view_closed_only')">
                                        <div class="dropdown me-2">
                                            <button type="button" class="btn btn-white btn-sm"
                                                @click="exportData(`${filter ?? 'all'}${filterDataUrl}`)">
                                                <i class="bi-download me-2"></i> Exporter
                                            </button>


                                        </div>
                                    </div>
                                </div>
                                <!-- @endif -->
                            </div>

                        </div>
                    </div>
                    <div class="card-body datatable-custom position-relative table-responsive">
                        <!-- Table HTML simple avec checkboxes -->
                        <table v-if="!isLoading" class="table table-borderless table-thead-bordered advanced-table whitespace-nowrap">
                            <thead>
                                <tr>
                                    <th style="width: 40px">
                                        <input type="checkbox"
                                            :checked="selectedIds.length === items.length && items.length > 0"
                                            @change="toggleSelectAll"
                                        />
                                    </th>
                                    <th>Sujet</th>
                                    <th>Réf</th>
                                    <th>Canal</th>
                                    <th>Statut</th>
                                    <th>Date</th>
                                    <th style="width: 100px">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in items" :key="item.id" @click="showComplaint(item)" style="cursor: pointer">
                                    <td @click.stop>
                                        <input type="checkbox"
                                            :checked="selectedIds.includes(item.id)"
                                            @change="toggleRowSelection(item.id)"
                                        />
                                    </td>
                                    <td>
                                        <div class="div">
                                            <b data-bs-toggle="tooltip" data-bs-html="true" :title="item.subject">
                                                {{ item.subject }}
                                            </b>
                                            <br>
                                            <p style="margin-bottom: 0px" data-bs-toggle="tooltip" data-bs-html="true"
                                                data-bs-placement="bottom" :title="limitText(item.description, 250)">
                                                {{ limitText(item.description, 250) }}
                                            </p>
                                            <span class="badge bg-soft-info text-info me-1" v-if="item.institution">
                                                {{ item.institution.label }}
                                            </span>

                                            <span class="badge bg-success text-white me-1"
                                                v-if="isAffected(item)"
                                                data-bs-toggle="tooltip"
                                                title="Cette plainte a déjà été affectée">
                                                <i class="bi bi-check-circle me-1"></i>Affectée
                                            </span>

                                            <div class="d-flex mt-3 flex-wrap gap-2 flex-grow-1 col-md-12">
                                                <span v-for="(val, key) in parsedInsight(item.ai_data?.insights)" :key="key"
                                                    class="badge badge-ia bg-warning text-dark">
                                                    {{ key }}: {{ limitText(val, 20) }}
                                                </span>
                                            </div>
                                        </div>
                                    </td>
                                    <td>{{ item.reference }}</td>
                                    <td>
                                        <span class="div">
                                            {{ item.complaintsubcategory?.label ?? "" }}
                                        </span>
                                    </td>
                                    <td>
                                        <span class="badge bg-soft-dark text-dark">
                                            {{ item.complaint_status?.description ?? " - " }}
                                        </span>
                                    </td>
                                    <td>{{ item.received_at }}</td>
                                    <td @click.stop>
                                        <div class="btn-group" role="group">
                                            <router-link :to="{ name: 'DossierShow', params: { id: item.id } }"
                                                class="btn btn-outline-dark btn-xs" title="Voir le résumé"
                                                data-bs-toggle="modal" data-bs-target="#complaintSummaryModal"
                                                @click="currentPlaint = item">
                                                <i class="bi bi-eye"></i>
                                            </router-link>

                                            <button class="btn btn-outline-dark btn-xs" title="Voir les pièces jointes"
                                                data-bs-toggle="modal" data-bs-target="#complaintFilesModal"
                                                @click="currentComplaintId = item.id; currentPlaint = item">
                                                <i class="bi-files"></i>
                                            </button>

                                            <div class="btn-group" role="group">
                                                <button type="button"
                                                    class="btn btn-outline-dark btn-xs dropdown-toggle"
                                                    data-bs-toggle="dropdown">
                                                    <i class="bi bi-three-dots"></i>
                                                </button>
                                                <ul class="dropdown-menu">
                                                    <li v-if="checkGuard('view_role') && !checkGuard('view_closed_only')">
                                                        <button class="dropdown-item" data-bs-toggle="modal"
                                                            data-bs-target="#affectationModal"
                                                            @click="currentPlaint = item">
                                                            <i class="bi-arrow-up-right-square dropdown-item-icon"></i>
                                                            Affecter
                                                        </button>
                                                    </li>
                                                    <li v-if="!checkGuard('view_closed_only')">
                                                        <button class="dropdown-item" data-bs-toggle="modal"
                                                            data-bs-target="#clotureModal"
                                                            @click="currentPlaint = item">
                                                            <i class="bi-arrow-up-right-square dropdown-item-icon"></i>
                                                            Cloturé
                                                        </button>
                                                    </li>
                                                    <li>
                                                        <router-link class="dropdown-item"
                                                            :to="{ name: 'DossierShow', params: { id: item.id } }">
                                                            <i class="bi-eye dropdown-item-icon"></i>
                                                            Consulter la fiche
                                                        </router-link>
                                                    </li>
                                                    <li>
                                                        <a class="dropdown-item" data-bs-toggle="modal"
                                                            data-bs-target="#complaintFilesModal">
                                                            <i class="bi-files dropdown-item-icon"></i>
                                                            Voir les pièces jointes
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <!-- Loader -->
                        <div v-if="isLoading" class="text-center my-5">
                            <div class="spinner-border text-primary" role="status">
                                <span class="visually-hidden">Chargement...</span>
                            </div>
                        </div>

                        <!-- Pas de résultat -->
                        <div v-if="!isLoading && items.length === 0" class="text-center my-5">
                            <p class="text-muted">Pas de résultat</p>
                        </div>

                        <!-- Pagination -->
                        <div v-if="!isLoading && items.length > 0 && itemsMeta" class="d-flex justify-content-between align-items-center mt-3">
                            <small class="text-muted">
                                {{ ((currentPage - 1) * 100) + 1 }} - {{ Math.min(currentPage * 100, itemsMeta) }} / {{ itemsMeta }} dossiers
                            </small>
                            <nav>
                                <ul class="pagination pagination-sm mb-0">
                                    <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                        <a class="page-link"
                                           @click.prevent="currentPage > 1 && preparePagination({ current_page: currentPage - 1 })"
                                           :href="currentPage === 1 ? '#' : ''">
                                            Précédent
                                        </a>
                                    </li>

                                    <!-- Pages cliquables -->
                                    <li v-for="page in visiblePages" :key="page"
                                        class="page-item"
                                        :class="{ active: page === currentPage, disabled: page === '...' }">
                                        <a v-if="page !== '...'"
                                           class="page-link"
                                           @click.prevent="preparePagination({ current_page: page })"
                                           :href="page === currentPage ? '#' : ''">
                                            {{ page }}
                                        </a>
                                        <span v-else class="page-link">...</span>
                                    </li>

                                    <li class="page-item" :class="{ disabled: currentPage >= totalPages }">
                                        <a class="page-link"
                                           @click.prevent="currentPage < totalPages && preparePagination({ current_page: currentPage + 1 })"
                                           :href="currentPage >= totalPages ? '#' : ''">
                                            Suivant
                                        </a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Button trigger modal -->
        <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#complaintSummaryModal"
            id="complaintSummaryModalButton" style="display: none"></button>
        <!-- End Button trigger modal -->

        <!-- Modal -->
        <div class="modal fade bd-example-modal-xl" id="complaintSummaryModal" tabindex="-1" role="dialog"
            aria-labelledby="complaintSummaryModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="complaintSummaryModalTitle">{{ currentPlaint?.subject }}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body" id="complaintSummaryModalBody">
                        {{ currentPlaint?.description }}
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-white" data-bs-dismiss="modal">Fermer</button>
                        <button type="button" class="btn btn-primary" style="display: none"></button>
                    </div>
                </div>
            </div>
        </div>
        <!-- End Modal -->


        <!-- Modal -->
        <div class="modal fade bd-example-modal-xl" id="complaintFilesModal" tabindex="-1" role="dialog"
            aria-labelledby="complaintFilesModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="complaintFilesModalTitle">Pièces jointes du dossier :
                            {{ currentPlaint?.subject }}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body" id="complaintFilesModalBody">

                        <!-- Loader -->
                        <div v-if="documentsLoading" class="text-center my-5">
                            <div class="spinner-border text-primary" role="status">
                                <span class="visually-hidden">Chargement...</span>
                            </div>
                            <p class="mt-2">Chargement des fichiers...</p>
                        </div>

                        <!-- Aucun fichier -->
                        <div v-else-if="!documentsLoading && complaintDocuments.length === 0" class="text-center my-5">
                            <i class="bi bi-file-ear-minus display-4 text-muted"></i>
                            <p class="text-muted mt-2">Aucun fichier joint</p>
                        </div>

                        <!-- Liste des fichiers -->
                        <div v-else class="documents-list">
                            <div class="table-responsive">
                                <table class="table table-hover mb-0">
                                    <thead class="table-light">
                                        <tr>
                                            <th width="50"></th>
                                            <th>Nom du fichier</th>
                                            <th>Taille</th>
                                            <th>Date d'ajout</th>
                                            <th class="text-end">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="doc in complaintDocuments" :key="doc.id">
                                            <td>
                                                <i :class="getDocumentIcon(doc) + ' fs-5'"></i>
                                            </td>
                                            <td>
                                                <div class="fw-semibold">{{ doc.name }}</div>
                                                <small class="text-muted">.{{ doc.extension }}</small>
                                            </td>
                                            <td>
                                                <span class="badge bg-light text-dark">{{ doc.full_size }}</span>
                                            </td>
                                            <td>
                                                <small class="text-muted">{{ formatDate(doc.created_at) }}</small>
                                            </td>
                                            <td class="text-end">
                                                <div class="btn-group btn-group-sm">
                                                    <button
                                                        v-if="doc.is_image || doc.is_pdf"
                                                        @click="previewDocument(doc)"
                                                        class="btn btn-outline-primary"
                                                        title="Prévisualiser"
                                                    >
                                                        <i class="bi bi-eye"></i>
                                                    </button>

                                                    <button
                                                        @click="downloadDocument(doc)"
                                                        class="btn btn-outline-success"
                                                        title="Télécharger"
                                                    >
                                                        <i class="bi bi-download"></i>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-white" data-bs-dismiss="modal">Fermer</button>
                        <button type="button" class="btn btn-primary" style="display: none"></button>
                    </div>
                </div>
            </div>
        </div>
        <!-- End Modal -->

        <!-- Button trigger modal -->
        <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
            id="affectationModalButtonClose" ref="affectationModalClose" style="display: none"></button>
        <!-- End Button trigger modal -->

        <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
            id="clotureModalButtonClose" ref="clotureModalClose" style="display: none"></button>

        <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#bulkAffectationModal"
            id="bulkAffectationModalButtonClose" ref="bulkAffectationModalClose" style="display: none"></button>

        <!-- Modal -->
        <div id="affectationModal" class="modal fade bd-example-modal-xl" tabindex="-1" role="dialog"
            aria-labelledby="affectationModalTitle" aria-hidden="true">
            <form id="affectationModalForm" @submit.prevent="prepareBeforeAffecte">

                <div class="modal-dialog modal-dialog-centered modal-xl" role="document">

                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="affectationModalTitle">AFFECTATION</h5>
                            <button type="button" class="btn-close" v-if="!affectationPlainteIsLoading"
                                data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div class="mb-3 tom-select-custom">
                                <label class="form-label" for="affectation_mode">Type d'affectation</label>
                                <m-select v-model="affectationData.affectation_mode_select"
                                    :loading="affectationIsLoading" :required="true" :options="affectationItems"
                                    :allow-empty="false" :searchable="false" placeholder="Type d'affectation"
                                    track-by="id" label="label">
                                </m-select>
                            </div>

                            <div id="affectation_mode_1" v-if="affectationData.affectation_mode == 1">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="mb-3">
                                            <label class="form-label" for="affectation_analystes">Analyste(s)</label>
                                            <m-select v-model="affectationData.affectation_analystes_select"
                                                :loading="userIsLoading" :required="true" :options="userItems"
                                                :multiple="true" :allow-empty="false" :searchable="true"
                                                placeholder="Rechercher des analystes..." track-by="id" label="firstname">
                                            </m-select>
                                            <small class="text-muted">
                                                {{ affectationData.affectation_analystes_select?.length || 0 }} analyste(s) sélectionné(s)
                                            </small>
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="mb-3">
                                            <label class="form-label" for="affectation_division">Division</label>
                                            <m-select v-model="affectationData.affectation_division"
                                                :loading="divisionIsLoading" :required="!createNewDivision" :options="divisionItems"
                                                :allow-empty="true" :searchable="true"
                                                placeholder="Rechercher une division..." track-by="id" label="label">
                                            </m-select>
                                            <div class="mt-2">
                                                <button type="button" class="btn btn-sm btn-outline-primary" @click="toggleCreateDivision">
                                                    <i class="bi bi-plus-circle me-1"></i>
                                                    Créer une division
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="mb-3">
                                            <label class="form-label" for="affectation_secteur">Secteur</label>
                                            <m-select v-model="affectationData.affectation_secteur"
                                                :loading="secteurIsLoading" :required="!createNewSecteur" :options="secteurItems"
                                                :allow-empty="true" :searchable="true"
                                                placeholder="Rechercher un secteur..." track-by="id" label="label">
                                            </m-select>
                                            <div class="mt-2">
                                                <button type="button" class="btn btn-sm btn-outline-primary" @click="toggleCreateSecteur">
                                                    <i class="bi bi-plus-circle me-1"></i>
                                                    Créer un secteur
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Formulaire création Division -->
                                    <div v-if="createNewDivision" class="col-md-12 mb-3">
                                        <div class="card border-info">
                                            <div class="card-header bg-info text-white py-2">
                                                <h6 class="mb-0">🏢 Nouvelle Division</h6>
                                            </div>
                                            <div class="card-body">
                                                <div class="row">
                                                    <div class="col-md-8">
                                                        <div class="mb-2">
                                                            <label class="form-label">Nom de la division *</label>
                                                            <input type="text" class="form-control form-control-sm"
                                                                v-model="newDivisionData.label"
                                                                placeholder="Ex: Division des affaires juridiques">
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <div class="mb-2">
                                                            <label class="form-label">Code</label>
                                                            <input type="text" class="form-control form-control-sm"
                                                                v-model="newDivisionData.code"
                                                                placeholder="Ex: DIV-001">
                                                        </div>
                                                    </div>
                                                </div>
                                                <button type="button" class="btn btn-success btn-sm"
                                                    @click="createNewDivisionOnly"
                                                    :disabled="!newDivisionData.label || creatingDivision">
                                                    <span v-if="creatingDivision">
                                                        <span class="spinner-border spinner-border-sm me-1"></span>
                                                        Création...
                                                    </span>
                                                    <span v-else>
                                                        <i class="bi bi-plus-circle me-1"></i>
                                                        Créer
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Formulaire création Secteur -->
                                    <div v-if="createNewSecteur" class="col-md-12 mb-3">
                                        <div class="card border-warning">
                                            <div class="card-header bg-warning text-dark py-2">
                                                <h6 class="mb-0">🏢 Nouveau Secteur</h6>
                                            </div>
                                            <div class="card-body">
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="mb-2">
                                                            <label class="form-label">Nom du secteur *</label>
                                                            <input type="text" class="form-control form-control-sm"
                                                                v-model="newSecteurData.label"
                                                                placeholder="Ex: Secteur des investigations">
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="mb-2">
                                                            <label class="form-label">Division associée *</label>
                                                            <select class="form-control form-control-sm"
                                                                v-model="newSecteurData.division_id"
                                                                required>
                                                                <option :value="null">Sélectionner une division...</option>
                                                                <option
                                                                    :value="division.id"
                                                                    v-for="(division, index) in divisionItems"
                                                                    :key="index">
                                                                    {{ division.label }}
                                                                </option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="mb-2">
                                                            <label class="form-label">Code</label>
                                                            <input type="text" class="form-control form-control-sm"
                                                                v-model="newSecteurData.code"
                                                                placeholder="Ex: SEC-001">
                                                        </div>
                                                    </div>
                                                </div>
                                                <button type="button" class="btn btn-success btn-sm"
                                                    @click="createNewSecteurOnly"
                                                    :disabled="!newSecteurData.label || !newSecteurData.division_id || creatingSecteur">
                                                    <span v-if="creatingSecteur">
                                                        <span class="spinner-border spinner-border-sm me-1"></span>
                                                        Création...
                                                    </span>
                                                    <span v-else>
                                                        <i class="bi bi-plus-circle me-1"></i>
                                                        Créer
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="mb-3">
                                            <label class="form-label" for="affectation_observations">Dispositions
                                                particulières</label>
                                            <textarea id="affectation_observations"
                                                v-model="affectationData.affectation_observations1"
                                                name="affectation_observations" class="form-control"
                                                placeholder="Dispositions particulières à observer lors du traitement du dossier. Appel à recourir à une documentation particulière"
                                                rows="4"></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="affectation_mode_2" v-if="affectationData.affectation_mode == 2">
                                <div class="mb-3 tom-select-custom">
                                    <label class="form-label" for="affectation_institution">Administration</label>
                                    <m-select v-model="affectationData.affectation_institution_select"
                                        :loading="institutionIsLoading" :required="!createNewInstitution" :options="institutionItems"
                                        :allow-empty="true" :searchable="true"
                                        :taggable="false"
                                        placeholder="Rechercher une administration..." track-by="id" label="label">
                                    </m-select>
                                    <small class="text-muted">
                                        <i class="bi bi-info-circle me-1"></i>
                                        Si vous ne trouvez pas l'institution, cochez la case ci-dessous pour en créer une nouvelle.
                                    </small>
                                </div>

                                <div class="mb-3">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="createNewInstitution"
                                            v-model="createNewInstitution" @change="resetInstitutionSelection">
                                        <label class="form-check-label fw-bold text-primary" for="createNewInstitution">
                                            <i class="bi bi-plus-circle me-1"></i>
                                            Créer une nouvelle institution
                                        </label>
                                    </div>
                                </div>

                                <div v-if="createNewInstitution" class="card border-primary mb-3">
                                    <div class="card-header bg-primary text-white">
                                        <h6 class="mb-0">🏢 Nouvelle Institution</h6>
                                    </div>
                                    <div class="card-body">
                                        <div class="mb-3">
                                            <label class="form-label" for="new_institution_label">Nom de l'institution *</label>
                                            <input type="text" class="form-control" id="new_institution_label"
                                                v-model="newInstitutionData.label"
                                                placeholder="Ex: Ministère de la Santé"
                                                :required="createNewInstitution">
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="mb-3">
                                                    <label class="form-label" for="new_institution_email">Email</label>
                                                    <input type="email" class="form-control" id="new_institution_email"
                                                        v-model="newInstitutionData.email"
                                                        placeholder="contact@institution.bj">
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="mb-3">
                                                    <label class="form-label" for="new_institution_phone">Téléphone</label>
                                                    <input type="text" class="form-control" id="new_institution_phone"
                                                        v-model="newInstitutionData.phone"
                                                        placeholder="+229 XX XX XX XX">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mb-3">
                                            <label class="form-label text-muted" for="new_institution_type">Type d'institution (optionnel)</label>
                                            <select class="form-select" id="new_institution_type" v-model="newInstitutionData.type">
                                                <option :value="null">Non spécifié</option>
                                                <option v-for="type in institutiontypeItems" :key="type.id" :value="type.id">
                                                    {{ type.label }}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="d-grid gap-2">
                                            <button type="button" class="btn btn-success"
                                                @click="createNewInstitutionOnly"
                                                :disabled="!newInstitutionData.label || creatingInstitution">
                                                <span v-if="creatingInstitution">
                                                    <span class="spinner-border spinner-border-sm me-2"></span>
                                                    Création en cours...
                                                </span>
                                                <span v-else>
                                                    <i class="bi bi-plus-circle me-2"></i>
                                                    Créer l'institution
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="affectation_mode_3" v-if="affectationData.affectation_mode == 3">
                                <div class="mb-3 tom-select-custom">
                                    <label class="form-label" for="affectation_motif">Motif</label>
                                    <m-select v-model="affectationData.affectation_motif_select"
                                        :loading="motifIsLoading" :required="true" :options="motifItems"
                                        :allow-empty="false" :searchable="false" placeholder="Choisissez un motif"
                                        track-by="id" label="label">
                                    </m-select>
                                </div>
                                <div class="mb-3">
                                    <label class="form-label" for="affectation_observations1">Autres details</label>
                                    <textarea id="affectation_observations1" name="affectation_observations1"
                                        class="form-control" placeholder=""
                                        v-model="affectationData.affectation_observations1" rows="4"></textarea>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-white" v-if="!affectationPlainteIsLoading"
                                data-bs-dismiss="modal">Fermer</button>
                            <button type="submit" class="btn btn-primary" v-if="!affectationPlainteIsLoading"
                                id="affectation_submit_button">Enregistrer</button>
                            <button type="button" class="btn btn-primary" disabled v-else
                                id="affectation_submit_button">En
                                cours de chargement</button>
                        </div>
                    </div>

                </div>
            </form>
        </div>
        <!-- End Modal -->


        <!-- Modal d'affectation groupée (BULK) -->
        <div id="bulkAffectationModal" class="modal fade bd-example-modal-xl" tabindex="-1" role="dialog"
            aria-labelledby="bulkAffectationModalTitle" aria-hidden="true">
            <form id="bulkAffectationModalForm" @submit.prevent="prepareBulkAffecte">

                <div class="modal-dialog modal-dialog-centered modal-xl" role="document">

                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="bulkAffectationModalTitle">
                                AFFECTATION GROUPÉE ({{ selectedIds.length }} dossiers)
                            </h5>
                            <button type="button" class="btn-close" v-if="!affectationPlainteIsLoading"
                                data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div class="alert alert-info">
                                <i class="bi bi-info-circle me-2"></i>
                                <strong>{{ selectedIds.length }}</strong> dossier(s) sélectionné(s) pour l'affectation groupée.
                            </div>

                            <div class="mb-3 tom-select-custom">
                                <label class="form-label" for="bulk_affectation_mode">Type d'affectation</label>
                                <m-select v-model="bulkAffectationData.affectation_mode_select"
                                    :loading="affectationIsLoading" :required="true" :options="affectationItems"
                                    :allow-empty="false" :searchable="false" placeholder="Type d'affectation"
                                    track-by="id" label="label">
                                </m-select>
                            </div>

                            <div id="bulk_affectation_mode_1" v-if="bulkAffectationData.affectation_mode == 1">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="mb-3">
                                            <label class="form-label" for="bulk_affectation_analystes">Analyste(s)</label>
                                            <m-select v-model="bulkAffectationData.affectation_analystes_select"
                                                :loading="userIsLoading" :required="true" :options="userItems"
                                                :multiple="true" :allow-empty="false" :searchable="true"
                                                placeholder="Rechercher des analystes..." track-by="id" label="firstname">
                                            </m-select>
                                            <small class="text-muted">
                                                {{ bulkAffectationData.affectation_analystes_select?.length || 0 }} analyste(s) sélectionné(s)
                                            </small>
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="mb-3">
                                            <label class="form-label" for="bulk_affectation_division">Division</label>
                                            <m-select v-model="bulkAffectationData.affectation_division"
                                                :loading="divisionIsLoading" :required="!createNewDivision" :options="divisionItems"
                                                :allow-empty="true" :searchable="true"
                                                placeholder="Rechercher une division..." track-by="id" label="label">
                                            </m-select>
                                            <div class="mt-2">
                                                <button type="button" class="btn btn-sm btn-outline-primary" @click="toggleCreateDivision">
                                                    <i class="bi bi-plus-circle me-1"></i>
                                                    Créer une division
                                                </button>
                                            </div>
                                            <div v-if="createNewDivision" class="mt-2 p-2 border rounded bg-light">
                                                <div class="mb-2">
                                                    <label class="form-label text-sm">Nom de la division *</label>
                                                    <input type="text" class="form-control form-control-sm"
                                                        v-model="newDivisionData.label"
                                                        placeholder="Ex: Direction des études">
                                                </div>
                                                <div class="mb-2">
                                                    <label class="form-label text-sm">Code (optionnel)</label>
                                                    <input type="text" class="form-control form-control-sm"
                                                        v-model="newDivisionData.code"
                                                        placeholder="Ex: DIR-ETU">
                                                </div>
                                                <button type="button" class="btn btn-sm btn-success"
                                                    @click="createNewDivisionOnly"
                                                    :disabled="creatingDivision">
                                                    <i class="bi bi-check-circle me-1"></i>
                                                    {{ creatingDivision ? 'Création...' : 'Créer' }}
                                                </button>
                                                <button type="button" class="btn btn-sm btn-secondary ms-1"
                                                    @click="toggleCreateDivision">
                                                    Annuler
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="mb-3">
                                            <label class="form-label" for="bulk_affectation_secteur">Secteur</label>
                                            <m-select v-model="bulkAffectationData.affectation_secteur"
                                                :loading="secteurIsLoading" :required="!createNewSecteur" :options="secteurItems"
                                                :allow-empty="true" :searchable="true"
                                                placeholder="Rechercher un secteur..." track-by="id" label="label">
                                            </m-select>
                                            <div class="mt-2">
                                                <button type="button" class="btn btn-sm btn-outline-primary" @click="toggleCreateSecteur">
                                                    <i class="bi bi-plus-circle me-1"></i>
                                                    Créer un secteur
                                                </button>
                                            </div>
                                            <div v-if="createNewSecteur" class="mt-2 p-2 border rounded bg-light">
                                                <div class="mb-2">
                                                    <label class="form-label text-sm">Nom du secteur *</label>
                                                    <input type="text" class="form-control form-control-sm"
                                                        v-model="newSecteurData.label"
                                                        placeholder="Ex: Secteur financier">
                                                </div>
                                                <div class="mb-2">
                                                    <label class="form-label text-sm">Division associée *</label>
                                                    <select class="form-control form-control-sm"
                                                        v-model="newSecteurData.division_id" required>
                                                        <option :value="null">Sélectionner une division...</option>
                                                        <option :value="division.id"
                                                            v-for="(division, index) in divisionItems"
                                                            :key="index">
                                                            {{ division.label }}
                                                        </option>
                                                    </select>
                                                </div>
                                                <div class="mb-2">
                                                    <label class="form-label text-sm">Code (optionnel)</label>
                                                    <input type="text" class="form-control form-control-sm"
                                                        v-model="newSecteurData.code"
                                                        placeholder="Ex: SEC-FIN">
                                                </div>
                                                <button type="button" class="btn btn-sm btn-success"
                                                    @click="createNewSecteurOnly"
                                                    :disabled="creatingSecteur">
                                                    <i class="bi bi-check-circle me-1"></i>
                                                    {{ creatingSecteur ? 'Création...' : 'Créer' }}
                                                </button>
                                                <button type="button" class="btn btn-sm btn-secondary ms-1"
                                                    @click="toggleCreateSecteur">
                                                    Annuler
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-12">
                                        <div class="mb-3">
                                            <label class="form-label" for="bulk_affectation_observations">Dispositions
                                                particulières</label>
                                            <textarea id="bulk_affectation_observations"
                                                v-model="bulkAffectationData.affectation_observations1"
                                                name="bulk_affectation_observations" class="form-control"
                                                placeholder="Dispositions particulières à observer lors du traitement des dossiers."
                                                rows="4"></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="bulk_affectation_mode_2" v-if="bulkAffectationData.affectation_mode == 2">
                                <div class="mb-3 tom-select-custom">
                                    <label class="form-label" for="bulk_affectation_institution">Administration</label>
                                    <m-select v-model="bulkAffectationData.affectation_institution_select"
                                        :loading="institutionIsLoading" :required="!createNewInstitution" :options="institutionItems"
                                        :allow-empty="true" :searchable="true"
                                        :taggable="false"
                                        placeholder="Rechercher une administration..." track-by="id" label="label">
                                    </m-select>
                                    <div class="mt-2">
                                        <button type="button" class="btn btn-sm btn-outline-primary" @click="toggleCreateInstitution">
                                            <i class="bi bi-plus-circle me-1"></i>
                                            Créer une administration
                                        </button>
                                    </div>
                                    <div v-if="createNewInstitution" class="mt-2 p-2 border rounded bg-light">
                                        <div class="mb-2">
                                            <label class="form-label text-sm">Nom de l'administration *</label>
                                            <input type="text" class="form-control form-control-sm"
                                                v-model="newInstitutionData.label"
                                                placeholder="Ex: Ministère de la Santé">
                                        </div>
                                        <div class="mb-2">
                                            <label class="form-label text-sm">Type d'institution</label>
                                            <select class="form-control form-control-sm"
                                                v-model="newInstitutionData.type">
                                                <option :value="null">Sélectionner un type...</option>
                                                <option :value="type.id"
                                                    v-for="(type, index) in institutiontypeItems"
                                                    :key="index">
                                                    {{ type.label }}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="mb-2">
                                            <label class="form-label text-sm">Email (optionnel)</label>
                                            <input type="email" class="form-control form-control-sm"
                                                v-model="newInstitutionData.email"
                                                placeholder="contact@institution.bj">
                                        </div>
                                        <div class="mb-2">
                                            <label class="form-label text-sm">Téléphone (optionnel)</label>
                                            <input type="text" class="form-control form-control-sm"
                                                v-model="newInstitutionData.phone"
                                                placeholder="+229 XX XX XX XX">
                                        </div>
                                        <button type="button" class="btn btn-sm btn-success"
                                            @click="createNewInstitutionOnly"
                                            :disabled="creatingInstitution">
                                            <i class="bi bi-check-circle me-1"></i>
                                            {{ creatingInstitution ? 'Création...' : 'Créer' }}
                                        </button>
                                        <button type="button" class="btn btn-sm btn-secondary ms-1"
                                            @click="toggleCreateInstitution">
                                            Annuler
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div id="bulk_affectation_mode_3" v-if="bulkAffectationData.affectation_mode == 3">
                                <div class="mb-3 tom-select-custom">
                                    <label class="form-label" for="bulk_affectation_motif">Motif</label>
                                    <m-select v-model="bulkAffectationData.affectation_motif_select"
                                        :loading="motifIsLoading" :required="true" :options="motifItems"
                                        :allow-empty="false" :searchable="false" placeholder="Choisissez un motif"
                                        track-by="id" label="label">
                                    </m-select>
                                </div>
                                <div class="mb-3">
                                    <label class="form-label" for="bulk_affectation_observations1">Autres details</label>
                                    <textarea id="bulk_affectation_observations1" name="bulk_affectation_observations1"
                                        class="form-control" placeholder=""
                                        v-model="bulkAffectationData.affectation_observations1" rows="4"></textarea>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-white" v-if="!affectationPlainteIsLoading"
                                data-bs-dismiss="modal">Fermer</button>
                            <button type="submit" class="btn btn-primary" v-if="!affectationPlainteIsLoading"
                                id="bulk_affectation_submit_button">Affecter {{ selectedIds.length }} dossier(s)</button>
                            <button type="button" class="btn btn-primary" disabled v-else
                                id="bulk_affectation_submit_button">En cours de chargement</button>
                        </div>
                    </div>

                </div>
            </form>
        </div>
        <!-- End Bulk Modal -->


        <!-- modal de cloture -->
        <div id="clotureModal" class="modal fade bd-example-modal-xl" tabindex="-1" role="dialog"
            aria-labelledby="clotureModalTitle" aria-hidden="true">
            <form id="clotureModalForm" @submit.prevent="prepareBeforeCloture">

                <div class="modal-dialog modal-dialog-centered modal-xl" role="document">

                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="clotureModalTitle">Clôture de la plainte</h5>
                            <button type="button" class="btn-close" v-if="!affectationPlainteIsLoading"
                                data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <p>Vous voulez clôturer la plainte
                                Elle ne sera pas rouverte.</p>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-white" v-if="!affectationPlainteIsLoading"
                                data-bs-dismiss="modal">Fermer</button>
                            <button type="submit" class="btn btn-primary" v-if="!affectationPlainteIsLoading"
                                id="affectation_submit_button">Clôturer</button>
                            <button type="button" class="btn btn-primary" disabled v-else
                                id="affectation_submit_button">En
                                cours de chargement</button>
                        </div>
                    </div>

                </div>
            </form>
        </div>


    </div>
</template>

<script>
import SubHeader from "@/layouts/admin/SubHeader.vue";
import { mapFields } from "vuex-map-fields"
import { mapActions } from "vuex";
import { columnFilterLang } from "@/utils";
import notify from "@/utils/notify.js"
import { checkGuard } from "@/utils/guards.js";
import backend from "@/utils/backend";



export default {
    name: "DossierListeFilter",
    components: {
        SubHeader
    },
    data() {
        return {
            cols: [
                { field: 'id', title: '', sort: false, width: '0px', type: 'number', hide: true, cellRenderer() { return "" } },
                { field: 'subject', title: 'Sujet', },
                { field: 'reference', title: 'Réf', },
                {
                    field: 'complaint_subcategory.label', title: 'Canal', cellRenderer({ complaintsubcategory }) {
                        return `<span class="div">
                                    ${complaintsubcategory?.label ?? ""} 
                                </span>`
                    }
                },
                {
                    field: 'complaint_status.label', title: 'Statut', cellRenderer({ complaint_status }) {
                        return `<span class="badge bg-soft-dark text-dark">
                                    ${complaint_status?.description ?? " - "}
                                </span>`
                    }
                },
                { field: 'received_at', title: 'Date', type: 'Date' },
                { field: 'action', title: 'Actions', filter: false, width: '10px', headerClass: 'justify-center', cellClass: 'justify-center' },

            ],
            selectedIds: [],  // IDs des dossiers sélectionnés pour affectation groupée
            currentPlaint: null,
            currentPage: 1,
            affectationData: {},
            bulkAffectationData: {},  // Données pour l'affectation groupée
            complaintDocuments: [],
            documentsLoading: false,
            currentComplaintId: null,
            createNewInstitution: false,
            creatingInstitution: false,
            newInstitutionData: {
                label: '',
                email: '',
                phone: '',
                type: null
            },
            createNewDivision: false,
            creatingDivision: false,
            newDivisionData: {
                label: '',
                code: ''
            },
            createNewSecteur: false,
            creatingSecteur: false,
            newSecteurData: {
                label: '',
                code: '',
                division_id: null
            },
            institutiontypeItems: [],
            institutiontypeIsLoading: false,
            searchWord: null,
            filterData: {
                institution_id: null,
                canal_id: null,
                date: []
            },
            filterDataUrl: "",
            columnFilterLang,

        }
    },

    computed: {
        ...mapFields("dossier/filter", {
            isLoading: "isLoading",
            isSuccess: "isSuccess",
            showMessage: "showMessage",
            message: "message",
            itemsMeta: "currentItem",
            items: "items"

        }),
        ...mapFields("category/list", {

            categoryIsLoading: "isLoading",
            categoryIsSuccess: "isSuccess",
            categoryShowMessage: "showMessage",
            categoryMessage: "message",
            categorySubCategory: "subcategory",
            categoryItems: "items"

        }),
        ...mapFields("dossier/affectation", {
            affectationPlainteIsLoading: "isLoading",
            affectationPlainteIsSuccess: "isSuccess",
            affectationPlainteShowMessage: "showMessage",
            affectationPlainteMessage: "message",
            affectationPlainteIsCreated: "isUpdated",
            cloturePlainteIsCreated: "isClose",
            affectationPlainteItems: "updated"

        }),
        ...mapFields("affectation/list", {
            affectationIsLoading: "isLoading",
            affectationIsSuccess: "isSuccess",
            affectationShowMessage: "showMessage",
            affectationMessage: "message",
            affectationItems: "items"

        }),
        ...mapFields("user/list", {
            userIsLoading: "isLoading",
            userIsSuccess: "isSuccess",
            userShowMessage: "showMessage",
            userMessage: "message",
            userItems: "items"

        }),
        ...mapFields("institution/list", {
            institutionIsLoading: "isLoading",
            institutionIsSuccess: "isSuccess",
            institutionShowMessage: "showMessage",
            institutionMessage: "message",
            institutionItems: "items"

        }),
        ...mapFields("caracterisation/list", {
            caracterisationIsLoading: "isLoading",
            caracterisationIsSuccess: "isSuccess",
            caracterisationShowMessage: "showMessage",
            caracterisationMessage: "message",
            caracterisationItems: "items"

        }),
        ...mapFields("division/list", {
            divisionIsLoading: "isLoading",
            divisionIsSuccess: "isSuccess",
            divisionShowMessage: "showMessage",
            divisionMessage: "message",
            divisionItems: "items"

        }),
        ...mapFields("secteur/list", {
            secteurIsLoading: "isLoading",
            secteurIsSuccess: "isSuccess",
            secteurShowMessage: "showMessage",
            secteurMessage: "message",
            secteurItems: "items"

        }),
        ...mapFields("motif/list", {
            motifIsLoading: "isLoading",
            motifIsSuccess: "isSuccess",
            motifShowMessage: "showMessage",
            motifMessage: "message",
            motifItems: "items"

        }),

        filter() {
            return this.$route.params.filter
        },
        subHeaderTitle() {
            const title = { "no_follow_up": "Dossiers sans suite", "administration": "Dossiers en traitement en administration", "internal": "Dossiers en traitement interne", "to_follow_up": "Dossiers non classés", "all": "Tous les dossiers" };

            return title[this.$route.params.filter] ?? "Tous les dossiers"
        },
        totalPages() {
            return Math.ceil(this.itemsMeta / 100);
        },
        visiblePages() {
            const pages = [];
            const total = this.totalPages;
            const current = this.currentPage;
            const delta = 2; // Nombre de pages de chaque côté

            if (total <= 7) {
                // Moins de 7 pages : tout afficher
                for (let i = 1; i <= total; i++) {
                    pages.push(i);
                }
            } else {
                // Plus de 7 pages : afficher avec des "..."
                pages.push(1);

                if (current <= delta + 2) {
                    // Début de la pagination
                    for (let i = 2; i <= delta + 2; i++) {
                        pages.push(i);
                    }
                    pages.push('...');
                    pages.push(total);
                } else if (current >= total - delta - 1) {
                    // Fin de la pagination
                    pages.push('...');
                    for (let i = total - delta - 1; i <= total; i++) {
                        pages.push(i);
                    }
                } else {
                    // Milieu de la pagination
                    pages.push('...');
                    for (let i = current - delta; i <= current + delta; i++) {
                        pages.push(i);
                    }
                    pages.push('...');
                    pages.push(total);
                }
            }

            return pages;
        }
    },

    methods: {
        // === Méthodes pour la sélection multiple ===
        toggleRowSelection(id) {
            const index = this.selectedIds.indexOf(id);
            if (index !== -1) {
                this.selectedIds.splice(index, 1);
            } else {
                this.selectedIds.push(id);
            }
        },

        toggleSelectAll(event) {
            if (event.target.checked) {
                this.items.forEach(item => {
                    if (!this.selectedIds.includes(item.id)) {
                        this.selectedIds.push(item.id);
                    }
                });
            } else {
                this.selectedIds = [];
            }
        },

        clearSelection() {
            this.selectedIds = [];
        },

        selectAllOnPage() {
            this.items.forEach(item => {
                if (!this.selectedIds.includes(item.id)) {
                    this.selectedIds.push(item.id);
                }
            });
        },

        // === Méthodes existantes ===
        checkGuard,
        preparePagination(data) {
            this.currentPage = data.current_page
            this.getDossiers({ filter: this.filter, page: this.currentPage + this.filterDataUrl })

        },
        filterDataSubmit(clickFilter = true) {
            let filterFormat = "";
            filterFormat += this.searchWord ? `&search=${this.searchWord ?? ' '}` : ''
            filterFormat += this.filterData.institution_id ? `&institution_id=${this.filterData.institution_id.id ?? '0'}` : ''
            filterFormat += this.filterData.canal_id ? `&canal_id=${this.filterData.canal_id.id ?? '0'}` : ''
            if (this.filterData.date?.length > 1) {
                filterFormat += this.filterData.date[0] ? `&start_date=${this.filterData.date[0] ?? 'null'}` : ''
                filterFormat += this.filterData.date[1] ? `&end_date=${this.filterData.date[1] ?? 'null'}` : ''
            }


            this.filterDataUrl = filterFormat;
            this.currentPage = 1;

            this.getDossiers({ filter: this.filter, page: "1" + filterFormat })
            if (clickFilter) {
                this.$refs.filter.click()
            }
        },
        resetFilterDataSubmit() {
            this.filterDataUrl = "";
            this.filterData = {
                institution_id: null,
                canal_id: null,
                date: []
            };
            this.currentPage = 1;
            this.getDossiers({ filter: this.filter, page: this.currentPage })
            this.$refs.filter.click()

        },
        ...mapActions({
            getDossiers: "dossier/filter/getPagination",
            exportData: "dossier/filter/exportData",
            reset: "dossier/filter/resetData",
            affectationHandleSubmit: "dossier/affectation/update",
            affectationHandleSubmitMany: "dossier/affectation/updateMany",
            clotureHandleSubmit: "dossier/affectation/cloture",
            resetAffectationCreate: "dossier/affectation/resetData",
            getAffectations: "affectation/list/getAll",
            resetAffectations: "affectation/list/resetData",
            getSecteurs: "secteur/list/getAll",
            resetSecteurs: "secteur/list/resetData",
            getDivisions: "division/list/getAll",
            resetDivisions: "division/list/resetData",
            getMotifs: "motif/list/getAll",
            resetMotifs: "motif/list/resetData",
            getInstitutions: "institution/list/getAll",
            resetInstitutions: "institution/list/resetData",
            getCaracterisations: "caracterisation/list/getAll",
            resetCaracterisations: "caracterisation/list/resetData",
            getUsers: "user/list/getAll",
            resetUsers: "user/list/resetData",
            getCategorys: "category/list/getAll",
            resetCategorys: "category/list/resetData",

        }),
        showComplaint(vale) {
            this.$router.push({ name: 'DossierShow', params: { id: vale.id } })
            // :to="{ name: 'DossierShow', params: { id: value.id } }
        },
        limitText(text, limit) {
            if (!text) return '';
            return text.length > limit ? text.substring(0, limit) + '...' : text;
        },
        parsedInsight(insights) {
            try {
                const parsed = JSON.parse(insights);
                if (parsed.Additionnel) {
                    const additionnel = parsed.Additionnel;
                    delete parsed.Additionnel;
                    for (const [key, value] of Object.entries(additionnel)) {
                        const formattedKey = key.replace(/_/g, ' ');
                        parsed[formattedKey] = value;
                    }
                }
                return parsed;
            } catch (error) {
                return {};
            }
        },
        isAffected(complaint) {
            if (!complaint) return false;

            // Vérifier si treatment_id est non null (plainte affectée/traitée)
            const hasTreatment = complaint.treatment_id !== null &&
                                complaint.treatment_id !== undefined;

            // Vérifier s'il y a une division OU un secteur assigné (affectation interne)
            const hasInternalAffectation = complaint.division || complaint.secteur;

            // Vérifier s'il y a des analystes assignés
            const hasAnalystes = complaint.analystes && complaint.analystes.length > 0;

            return hasTreatment || hasInternalAffectation || hasAnalystes;
        },
        prepareBeforeAffecte() {
            var list_fileds = ["affectation_mode", "affectation_motif", "affectation_observations1"]
            if (this.affectationData.affectation_mode == 1) {
                // Mode interne - vérifier les créations en cours
                if (this.createNewDivision || this.createNewSecteur) {
                    notify('Veuillez d\'abord créer la division/secteur avant d\'affecter', 'error')
                    return
                }
                list_fileds = ["affectation_mode", "affectation_observations1", "affectation_secteur_id", "affectation_division_id", "affectation_analystes"];
            } else if (this.affectationData.affectation_mode == 2) {
                // Mode administration - ne pas permettre d'affecter si on est en mode création
                if (this.createNewInstitution) {
                    notify('Veuillez d\'abord créer l\'institution avant d\'affecter', 'error')
                    return
                }
                list_fileds = ["affectation_institution", "affectation_mode"]
            }

            var data = { id: this.currentPlaint?.id };
            list_fileds.forEach((field) => {
                data[field] = this.affectationData[field]
            })

            this.affectationHandleSubmit(data)

        },

        // === Affectation groupée (BULK) ===
        prepareBulkAffecte() {
            // RESET AVANT l'appel API pour garantir un état propre
            this.resetAffectationCreate()

            // Vérifier qu'il y a des dossiers sélectionnés
            if (this.selectedIds.length === 0) {
                notify('Veuillez sélectionner au moins un dossier', 'error')
                return
            }

            if (this.createNewDivision || this.createNewSecteur || this.createNewInstitution) {
                notify('Veuillez terminer la création en cours ou annuler avant d\'affecter.', 'warning')
                return
            }

            // Préparer les données selon le mode
            let dataToSend = {
                ids: this.selectedIds,
                affectation_mode: this.bulkAffectationData.affectation_mode
            }

            if (this.bulkAffectationData.affectation_mode == 1) {
                // Mode interne - envoyer uniquement les IDs
                dataToSend.affectation_analystes_select_id = this.bulkAffectationData.affectation_analystes_select_id || []
                dataToSend.affectation_division = this.bulkAffectationData.affectation_division_id || this.bulkAffectationData.affectation_division?.id || null
                dataToSend.affectation_secteur = this.bulkAffectationData.affectation_secteur_id || this.bulkAffectationData.affectation_secteur?.id || null
                dataToSend.affectation_observations = this.bulkAffectationData.affectation_observations1
            } else if (this.bulkAffectationData.affectation_mode == 2) {
                // Mode administration
                dataToSend.affectation_institution = this.bulkAffectationData.affectation_institution || this.bulkAffectationData.affectation_institution_id
            } else if (this.bulkAffectationData.affectation_mode == 3) {
                // Mode classement
                dataToSend.affectation_motif = this.bulkAffectationData.affectation_motif_id
                dataToSend.affectation_observations = this.bulkAffectationData.affectation_observations1
            }

            // Appel avec promesse - gestion DIRECTE du succès sans watcher
            this.affectationHandleSubmitMany(dataToSend).then(() => {
                // Reset de l'affectation
                this.resetAffectationCreate();

                // Notify et reload des données AVANT de fermer le modal
                notify(`<div class="ml-2" style="margin-left:10px"><b>Super,La plainte a été traitée</b></div>`, "success")
                this.getDossiers({ filter: this.filter, page: this.currentPage + this.filterDataUrl })

                // Fermer le modal selon le contexte
                if (this.selectedIds.length > 0) {
                    this.$refs.bulkAffectationModalClose.click();
                    this.clearSelection()
                    this.bulkAffectationData = {}
                    this.selectedIds = []
                } else {
                    this.$refs.affectationModalClose.click();
                }
            }).catch(() => {
                // Erreur silencieuse - le store gère l'affichage
            })
        },

        prepareBeforeCloture() {
            var data = { id: this.currentPlaint?.id };
            data["complaint_status_label"] = "ADM_TREATMENT_ENCLOSED";
            this.clotureHandleSubmit(data)

        },

        async loadComplaintDocuments(complaintId) {
            if (!complaintId) {
                this.complaintDocuments = []
                return
            }

            this.documentsLoading = true
            try {
                const response = await backend({ method: 'GET', url: `/complaints/${complaintId}/documents` })
                this.complaintDocuments = response.data.data || []
            } catch (error) {
                console.error('Erreur lors du chargement des documents:', error)
                notify('Impossible de charger les documents', 'error')
                this.complaintDocuments = []
            } finally {
                this.documentsLoading = false
            }
        },

        getDocumentIcon(doc) {
            if (doc.is_image) return 'bi-file-ear-image text-primary'
            if (doc.is_pdf) return 'bi-file-ear-pdf text-danger'
            if (doc.extension === 'doc' || doc.extension === 'docx') return 'bi-file-ear-word text-primary'
            if (doc.extension === 'xls' || doc.extension === 'xlsx') return 'bi-file-ear-excel text-success'
            return 'bi-file-ear text-secondary'
        },

        previewDocument(doc) {
            // Ouvrir directement l'URL du fichier
            window.open(doc.url, '_blank')
        },

        downloadDocument(doc) {
            // Créer un lien temporaire pour forcer le téléchargement
            const link = document.createElement('a')
            link.href = doc.url
            link.download = doc.name
            link.target = '_blank'
            document.body.appendChild(link)
            link.click()
            link.remove()
        },

        formatDate(dateString) {
            if (!dateString) return '-'
            const date = new Date(dateString)
            return date.toLocaleDateString('fr-FR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            })
        },

        async getInstitutionTypes() {
            this.institutiontypeIsLoading = true
            try {
                const response = await backend({ method: 'GET', url: '/institution-type' })
                this.institutiontypeItems = response.data.data || []
            } catch (error) {
                console.error('Erreur lors du chargement des types d\'institutions:', error)
                this.institutiontypeItems = []
            } finally {
                this.institutiontypeIsLoading = false
            }
        },

        resetInstitutionSelection() {
            if (this.createNewInstitution) {
                // Vider la sélection d'institution existante
                this.affectationData.affectation_institution_select = null
            }
        },

        toggleCreateInstitution() {
            this.createNewInstitution = !this.createNewInstitution
            this.newInstitutionData = { label: '', email: '', phone: '', type: null }
        },

        async createNewInstitutionOnly() {
            if (!this.newInstitutionData.label) {
                notify('Le nom de l\'institution est obligatoire', 'error')
                return
            }

            this.creatingInstitution = true
            try {
                // Créer l'institution via l'API
                const data = {
                    label: this.newInstitutionData.label,
                    institutiontype_id: this.newInstitutionData.type || null,
                    email: this.newInstitutionData.email || null,
                    phone: this.newInstitutionData.phone || null,
                }

                await backend({
                    method: 'POST',
                    url: '/institutions',
                    data
                })

                // Succès
                notify(`Institution "${this.newInstitutionData.label}" créée avec succès !`, 'success')

                // Réinitialiser le formulaire
                this.newInstitutionData = {
                    label: '',
                    email: '',
                    phone: '',
                    type: null
                }
                this.createNewInstitution = false

                // Rafraîchir la liste des institutions
                await this.getInstitutions()

                // Afficher un message pour demander de sélectionner
                setTimeout(() => {
                    notify('✅ Institution ajoutée ! Sélectionnez-la maintenant dans la liste.', 'info')
                }, 500)

            } catch (error) {
                console.error('Erreur lors de la création de l\'institution:', error)
                const errorMsg = error.response?.data?.message || 'Impossible de créer cette institution'
                notify(errorMsg, 'error')
            } finally {
                this.creatingInstitution = false
            }
        },

        // Méthodes pour Division
        toggleCreateDivision() {
            this.createNewDivision = !this.createNewDivision
            if (this.createNewDivision) {
                this.affectationData.affectation_division = null
            }
        },

        async createNewDivisionOnly() {
            if (!this.newDivisionData.label) {
                notify('Le nom de la division est obligatoire', 'error')
                return
            }

            this.creatingDivision = true
            try {
                const data = {
                    label: this.newDivisionData.label,
                    code: this.newDivisionData.code || null,
                }

                await backend({
                    method: 'POST',
                    url: '/divisions',
                    data
                })

                notify(`Division "${this.newDivisionData.label}" créée avec succès !`, 'success')

                this.newDivisionData = { label: '', code: '' }
                this.createNewDivision = false

                await this.getDivisions()

                setTimeout(() => {
                    notify('✅ Division ajoutée ! Sélectionnez-la maintenant.', 'info')
                }, 500)

            } catch (error) {
                console.error('Erreur lors de la création de la division:', error)
                const errorMsg = error.response?.data?.message || 'Impossible de créer cette division'
                notify(errorMsg, 'error')
            } finally {
                this.creatingDivision = false
            }
        },

        // Méthodes pour Secteur
        toggleCreateSecteur() {
            this.createNewSecteur = !this.createNewSecteur
            if (this.createNewSecteur) {
                this.affectationData.affectation_secteur = null
            }
        },

        async createNewSecteurOnly() {
            if (!this.newSecteurData.label) {
                notify('Le nom du secteur est obligatoire', 'error')
                return
            }
            if (!this.newSecteurData.division_id) {
                notify('Veuillez sélectionner une division', 'error')
                return
            }

            this.creatingSecteur = true
            try {
                const data = {
                    label: this.newSecteurData.label,
                    code: this.newSecteurData.code || null,
                    division_id: this.newSecteurData.division_id,
                }

                await backend({
                    method: 'POST',
                    url: '/secteurs',
                    data
                })

                notify(`Secteur "${this.newSecteurData.label}" créé avec succès !`, 'success')

                this.newSecteurData = { label: '', code: '', division_id: null }
                this.createNewSecteur = false

                await this.getSecteurs()

                setTimeout(() => {
                    notify('✅ Secteur ajouté ! Sélectionnez-le maintenant.', 'info')
                }, 500)

            } catch (error) {
                console.error('Erreur lors de la création du secteur:', error)
                const errorMsg = error.response?.data?.message || 'Impossible de créer ce secteur'
                notify(errorMsg, 'error')
            } finally {
                this.creatingSecteur = false
            }
        }
    },
    watch: {
        searchWord() {
            this.filterDataSubmit(false)
        },

        filter(filt) {
            this.getDossiers({ filter: filt, page: "1" + this.filterDataUrl })
        },

        "affectationData.affectation_mode_select"(val) {
            if (val) {
                this.affectationData.affectation_mode = val.id
            }
        },
        "affectationData.affectation_institution_select"(val) {
            if (val) {
                this.affectationData.affectation_institution = val.id
            }
        },
        "affectationData.affectation_motif_select"(val) {
            if (val) {
                this.affectationData.affectation_motif = val.id
            }
        },
        "affectationData.affectation_analystes_select"(val) {

            this.affectationData.affectation_analystes = val.map(({ id }) => id)

        },
        "affectationData.affectation_secteur"(val) {
            if (val) {
                this.affectationData.affectation_secteur_id = val.id
            }
        },
        "affectationData.affectation_division"(val) {
            if (val) {
                this.affectationData.affectation_division_id = val.id
            }
        },

        // Watchers pour l'affectation groupée (BULK)
        "bulkAffectationData.affectation_mode_select"(val) {
            if (val) {
                this.bulkAffectationData.affectation_mode = val.id
            }
        },
        "bulkAffectationData.affectation_institution_select"(val) {
            if (val) {
                this.bulkAffectationData.affectation_institution = val.id
            }
        },
        "bulkAffectationData.affectation_motif_select"(val) {
            if (val) {
                this.bulkAffectationData.affectation_motif = val.id
            }
        },
        "bulkAffectationData.affectation_analystes_select"(val) {
            if (val) {
                this.bulkAffectationData.affectation_analystes_select_id = val.map(({ id }) => id)
            }
        },
        "bulkAffectationData.affectation_secteur"(val) {
            if (val) {
                this.bulkAffectationData.affectation_secteur_id = val.id
            }
        },
        "bulkAffectationData.affectation_division"(val) {
            if (val) {
                this.bulkAffectationData.affectation_division_id = val.id
            }
        },
        cloturePlainteIsCreated(val) {
            if (val) {
                this.$refs.clotureModalClose.click();
                notify(`<div class="ml-2" style="margin-left:10px"><b>Super,La plainte a été Cloturée</b></div>`, "success")
                this.getDossiers({ filter: this.filter, page: this.currentPage + this.filterDataUrl })
            }
        },
    },
    mounted() {
        this.getDossiers({ filter: this.filter, page: this.currentPage + this.filterDataUrl })
        this.getAffectations()
        this.getInstitutions()
        this.getInstitutionTypes()
        this.getCaracterisations()
        this.getDivisions()
        this.getSecteurs()
        this.getMotifs()
        this.getUsers()
        this.getCategorys()

        // Ajouter l'écouteur d'événement pour le modal des fichiers
        this.$nextTick(() => {
            const filesModal = document.getElementById('complaintFilesModal')
            if (filesModal) {
                filesModal.addEventListener('show.bs.modal', () => {
                    // Attendre un peu que Vue mette à jour les données
                    setTimeout(() => {
                        if (this.currentComplaintId) {
                            this.loadComplaintDocuments(this.currentComplaintId)
                        }
                    }, 50)
                })
            }
        })
    },
    unmounted() {
        this.reset()
        this.resetAffectations()
        this.resetInstitutions()
        this.resetCaracterisations()
        this.resetDivisions()
        this.resetSecteurs()
        this.resetMotifs()
        this.resetAffectationCreate()
        this.resetCategorys()
    }
}
</script>
<style scoped>
.badge-ia {
    font-size: 0.9rem;
    margin-bottom: 5px;
    padding: 0.3rem 0.6rem;
}
</style>
